<template>
  <div class="crime-items d-flex justify-content-between">
    <a
      href="javascript:;"
      class="cirme-wrap d-flex align-items-center gap-3"
      @click.prevent="
        $router.push({ name: 'game.show', params: { slug: game.slug } })
      "
    >
      <div class="crime-thumb">
        <img
          v-lazy="game.thumb_small"
          :alt="game.title"
          loading="lazy"
          style="width: 100%; height: 100%; aspect-ratio: 1/1; object-fit: cover;"
        />
      </div>
      <div class="crime-content">
        <h5>
          {{ game.title }}
        </h5>
        <p>
          {{ game.categories.map((category) => category.name).join(", ") }}
        </p>
      </div>
    </a>
    <a
      href="javascript:;"
      class="video-btn"
      @click.prevent="
        $router.push({ name: 'game.show', params: { slug: game.slug } })
      "
    >
      <i class="fas fa-play"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: "GameRouned",
  props: {
    game: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.letest-wrapper .crime-items .crime-thumb {
  width: 120px !important;
}
.crime-content {
  width: 100% !important;
}
</style>